import { SchemeType } from '@/shared/types/api.types'

export const OUTBOUND_MULTI_TRIP_RETURN_DAY = 364

export const PLAN_NAMES_SCHEME_TYPE_CODE_MAP = {
  [SchemeType.Worldwide]: 'outbound.select_plan.insurance_values.plan.worldwide.name',
  [SchemeType.WorldwideExcl]: 'outbound.select_plan.insurance_values.plan.worldwideexcl.name',
  [SchemeType.Regional]: 'outbound.select_plan.insurance_values.plan.regional.name',
  [SchemeType.FlyEurope]: 'outbound.select_plan.insurance_values.plan.flyeurope.name',
}

export const PLAN_NAMES_SCHEME_TYPE_CODE_MAP_V3 = {
  [SchemeType.Worldwide]: 'outbound.plan.worldwide.name',
  [SchemeType.WorldwideExcl]: 'outbound.plan.worldwide_limited.name',
  [SchemeType.Regional]: 'outbound.plan.regional.name',
  [SchemeType.FlyEurope]: 'outbound.plan.europe.name',
}
